
import React from 'react';
import { Routes } from 'react-router-dom';
import AppProviders from '@/components/providers/AppProviders';
import AdminRoutes from '@/components/routes/AdminRoutes';
import AuthorRoutes from '@/components/routes/AuthorRoutes';
import CommonRoutes from '@/components/routes/CommonRoutes';

const App = () => {
  console.log('App: Rendering');
  
  return (
    <AppProviders>
      <Routes>
        {CommonRoutes()}
        {AdminRoutes()}
        {AuthorRoutes()}
      </Routes>
    </AppProviders>
  );
};

export default App;
